<template>
  <d2-container>
    <top-line :message="pageTitle" :iconclass="'fa fa-briefcase'"></top-line>
    <el-row class="pagebody">
      <!-- 搜索过滤栏 -->
      <el-card shadow="never" class="filter-bar">
        <el-form :inline="true" :model="searchForm" ref="searchForm" size="small" label-width="100px">
          <el-row>
            <!-- 客户名称 -->
            <el-col :span="6">
              <el-form-item label="客户名称" prop="customer_name">
                <el-input
                  v-model="searchForm.customer_name"
                  placeholder="请输入客户名称"
                  style="width: 175px"
                  clearable
                />
              </el-form-item>
            </el-col>

            <!-- GPU型号 -->
            <el-col :span="6">
              <el-form-item label="GPU型号" prop="gpu_model">
                <el-input
                  v-model="searchForm.gpu_model"
                  placeholder="请输入GPU型号"
                  style="width: 175px"
                  clearable
                />
              </el-form-item>
            </el-col>

            <!-- 合同类型 -->
            <el-col :span="6">
              <el-form-item label="合同类型" prop="contract_type">
                <el-select
                  v-model="searchForm.contract_type"
                  placeholder="请选择合同类型"
                  style="width: 175px"
                  clearable
                >
                  <el-option label="开口合同" :value="0"></el-option>
                  <el-option label="闭口合同" :value="1"></el-option>
                  <el-option label="售前测试" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <!-- 商机可信性 -->
            <el-col :span="6">
              <el-form-item label="可信性" prop="reliability">
                <el-select
                  v-model="searchForm.reliability"
                  placeholder="请选择可信性"
                  style="width: 175px"
                  clearable
                >
                  <el-option label="高" :value="1"></el-option>
                  <el-option label="中" :value="2"></el-option>
                  <el-option label="低" :value="3"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <!-- 操作按钮 -->
            <el-col :span="24" style="text-align: right; padding-top: 10px;">
              <el-button type="primary" icon="el-icon-search" size="small" @click="handleSearch">查询</el-button>
              <el-button type="info" icon="el-icon-refresh-left" size="small" @click="handleReset" style="margin-left: 8px">重置</el-button>
              <el-button
                type="success"
                size="small"
                icon="el-icon-plus"
                plain
                @click="handleCreate"
              >
                新增商机
              </el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-card>

      <!-- 表格 -->
      <el-table
        :data="tableData"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column prop="customer_name" label="客户名称" min-width="140" show-overflow-tooltip />

        <el-table-column prop="expected_start_time" label="期望起租时间" width="170">
          <template #default="{ row }">
            {{ formatDateTime(row.expected_start_time) }}
          </template>
        </el-table-column>

        <el-table-column prop="gpu_model" label="需求GPU型号" min-width="140" show-overflow-tooltip />
        <el-table-column prop="quantity" label="需求台数" min-width="100" align="center" />

        <el-table-column prop="details" label="具体需求" min-width="160" show-overflow-tooltip />
        <el-table-column prop="expected_price" label="期望价格" min-width="120" />

        <!-- 合同类型（Tag） -->
        <el-table-column prop="contract_type" label="合同类型" min-width="130">
          <template #default="{ row }">
            <el-tag
              :type="row.contract_type === 0 ? 'success' : row.contract_type === 1 ? 'info' : 'warning'"
              size="small"
            >
              {{ contractTypeLabel(row.contract_type) }}
            </el-tag>
          </template>
        </el-table-column>

        <!-- 商机可信性（Tag） -->
        <el-table-column prop="reliability" label="商机可信性" min-width="120">
          <template #default="{ row }">
            <el-tag
              :type="row.reliability === 1 ? 'success' : row.reliability === 2 ? 'primary' : 'danger'"
              size="small"
            >
              {{ reliabilityLabel(row.reliability) }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="remark" label="备注" min-width="130" show-overflow-tooltip />
        <el-table-column fixed="right" label="操作" width="200" align="center">
            <template v-slot="scope">
              <el-button type="text" size="mini" @click="handleEdit(scope.row)">
                编辑
              </el-button>
              <el-button type="text" size="mini" @click="handleDelete(scope.row)">
                删除
              </el-button>
            </template>
          </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-row type="flex" justify="left" style="margin-top: 15px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pagination.page"
          :page-sizes="pagination.pageSizeList"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </el-row>
    </el-row>

    <!-- 新增/编辑弹窗 -->
    <CreateBusinessOpportunity ref="createOpportunity" @success="getTableData" />
     <!-- 弹窗组件 -->
    <EditBusinessOpportunity  ref="editOpportunity"  @success="getTableData"/>

  </d2-container>
</template>

<script>
import topLine from "@/components/save-common/topLine.vue";
import { MessageBox } from 'element-ui';
import CreateBusinessOpportunity from '../opportunities/CreateBusinessOpportunity.vue';
import EditBusinessOpportunity from '../opportunities/EditBusinessOpportunity.vue';


export default {
  name: "business-opportunity",
  components: {
    topLine,
    CreateBusinessOpportunity,
    EditBusinessOpportunity
  },
  mounted() {
    this.loadParams();
  },
  data() {
    return {
      pageTitle: "商机管理",
      tableDataApi: '/api-30216/api/opportunities', // 替换为真实接口
      searchForm: {
        customer_name: '',
        gpu_model: '',
        contract_type: '',
        reliability: '',
        page: parseInt(this.$route.query.page) || 1,
        pageSize: parseInt(this.$route.query.pageSize) || 10,
      },
      pagination: {
        page: parseInt(this.$route.query.page) || 1,
        pageSize: parseInt(this.$route.query.pageSize) || 10,
        total: 0,
        pageSizeList: [10, 20, 50, 100]
      },
      tableData: []
    };
  },
  methods: {
    formatDateTime(datetime) {
      if (!datetime) return '';
      const date = new Date(datetime);
      const Y = date.getFullYear() + '-';
      const M = (date.getMonth() + 1).toString().padStart(2, '0') + '-';
      const D = date.getDate().toString().padStart(2, '0') + ' ';
      const h = date.getHours().toString().padStart(2, '0') + ':';
      const m = date.getMinutes().toString().padStart(2, '0') + ':';
      const s = date.getSeconds().toString().padStart(2, '0');
      return Y + M + D + h + m + s;
    },

    contractTypeLabel(value) {
      const labels = { 0: '开口合同', 1: '闭口合同', 2: '售前测试' };
      return labels[value] || '未知';
    },

    reliabilityLabel(value) {
      const labels = { 1: '高', 2: '中', 3: '低' };
      return labels[value] || '未知';
    },

    loadParams() {
      const query = this.$route.query;
      if (query.page) this.pagination.page = parseInt(query.page, 10);
      if (query.pageSize) this.pagination.pageSize = parseInt(query.pageSize, 10);
      this.getTableData();
    },

    handleReset() {
      this.searchForm = {
        customer_name: '',
        gpu_model: '',
        contract_type: '',
        reliability: '',
        page: 1,
        pageSize: this.pagination.pageSize
      };
      this.getTableData();
    },

    handleSearch() {
      this.pagination.page = 1;
      this.getTableData();
    },

    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.getTableData();
    },

    handleCurrentChange(page) {
      this.pagination.page = page;
      this.getTableData();
    },

    getTableData() {
      const params = { ...this.searchForm };
      params.page = this.pagination.page;
      params.pageSize = this.pagination.pageSize;

      this.$axios.get(this.tableDataApi, { params })
        .then(response => {
          const data = response.data || {};
          this.tableData = Array.isArray(data) ? data : (data.list || []);
          this.pagination.total = data.total || response.total || 0;
        })
        .catch(err => {
          console.error('获取商机数据失败', err);
          this.$message.error('数据加载失败');
        });
    },

    // 新增
    handleCreate() {
      if (this.$refs.createOpportunity && typeof this.$refs.createOpportunity.openDialog === 'function') {
        this.$refs.createOpportunity.openDialog();
      }
    },

     // 编辑菜单
    handleEdit(row) {
      this.$refs.editOpportunity.openDialog({ id: row.id });
    },


    // 删除商机
    handleDelete(row) {
      this.$confirm(`确定要删除商机 “[${row.customer_name}]” ？`, '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 调用删除接口
          this.$axios
            .delete(`/api-30216/api/opportunities/${row.id}`)
            .then((res) => {
              if (res.code === 200) {
                this.$message.success('删除成功');
                this.getTableData();
              } else {
                this.$message.error(res.message || '删除失败');
              }
            })
            .catch((err) => {
              // console.error('删除失败：', err);
              // this.$message.error('删除请求失败');
            });
        })
        .catch(() => {
          this.$message.info('已取消删除');
        });
    }
  }
};
</script>

<style scoped lang="scss">
.pagebody {
  margin: 20px;
}
.filter-bar {
  margin-bottom: 15px;
}
</style>